import { Breadcrumbs } from "../../../AbstractElements";
import { Ecommerce, Wishlist } from "../../../Constant";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { WishlistData } from "./WishlistData";

const WhishListContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Wishlist} parent={Ecommerce} title={Wishlist} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={Wishlist} />
              <CardBody>
                <WishlistData />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default WhishListContainer;
